import DeveloperSection from './DeveloperSection';

const exports = {
    Page: DeveloperSection,
};

export default exports;
